document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("pq-member-redeem-detail")) {
    customElements.define(
      "pq-member-redeem-detail",
      class PqMemberRedeemDetail extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();

          const codeContainer = this.querySelector(
            ".pq-member-redeem-detail__code"
          );
          const copyIcon = codeContainer?.querySelector("i");
          const codeSpan = codeContainer?.querySelector("span");
       
          if (copyIcon && codeSpan) {
            copyIcon.addEventListener("click", () => {
              const codeValue = codeContainer.getAttribute("data-code");
              window.pq.copyToClipboard(codeValue);
            });
          }
        }

        init() {
          const memberRedeemScrollContainer = this.querySelector(
            ".member-redeem-scroll-container"
          );
          if (memberRedeemScrollContainer) {
            this.handleScroll();
            memberRedeemScrollContainer.addEventListener(
              "scroll",
              this.handleScroll.bind(this)
            );
          }
        }

        handleScroll() {
          const memberRedeemScrollContainer = this.querySelector(
            ".member-redeem-scroll-container"
          );
          const memberRedeemModalBtnRedeemWrapper = this.querySelector(
            ".member-redeem-modal-btn-redeem_wrapper"
          );
          const memberRedeemModalBtn = this.querySelector(
            ".member-redeem-modal-btn"
          );

          if (
            memberRedeemScrollContainer &&
            memberRedeemModalBtnRedeemWrapper &&
            memberRedeemModalBtn
          ) {
            if (
              memberRedeemScrollContainer.scrollTop +
                memberRedeemScrollContainer.clientHeight >=
              memberRedeemScrollContainer.scrollHeight
            ) {
              memberRedeemModalBtnRedeemWrapper.classList.add(
                "pq-member-redeem-detail__border-t"
              );
              memberRedeemModalBtn.style.boxShadow = "none";
            } else {
              memberRedeemModalBtnRedeemWrapper.classList.remove(
                "pq-member-redeem-detail__border-t"
              );
              memberRedeemModalBtn.style.boxShadow = "0 0 4px 0px #0000001a";
            }
          }
        }

        disconnectedCallback() {
          const memberRedeemScrollContainer = this.querySelector(
            ".member-redeem-scroll-container"
          );
          if (memberRedeemScrollContainer) {
            memberRedeemScrollContainer.removeEventListener(
              "scroll",
              this.handleScroll.bind(this)
            );
          }
        }
      }
    );
  }
});
